import { BaseProvider } from '@!/providers'

export const ColophonProvider = (props) => {
  return <BaseProvider {...props}>{props.children}</BaseProvider>
}
